import Reveal from "./Reveal";

const ITEMS = [
  {
    glyph: "Re",
    title: "Rekonstrukce",
    text: "Dáváme prostorům nový dech a smysl.",
    num: "01",
  },
  {
    glyph: "St",
    title: "Stavby",
    text: "Tvoříme spolehlivé a pevné základy pro váš život.",
    num: "02",
  },
  {
    glyph: "Art",
    title: "Umění",
    text: "K řemeslu přistupujeme jako k umění — s maximálním respektem k detailu.",
    num: "03",
  },
  {
    glyph: "PRO",
    title: "Profesionalita",
    text: "Přes 20 let praxe. Za každý krok ručíme.",
    num: "04",
  },
];

export default function Decoding() {
  return (
    <section id="dekodovani" data-testid="decoding-section" className="py-24 lg:py-32 bg-ink">
      <div className="max-w-7xl mx-auto px-4 sm:px-8 lg:px-16">
        <Reveal>
          <p className="text-xs font-mono tracking-[0.3em] uppercase text-gold/70 mb-4">
            Co znamená RESTART PRO
          </p>
          <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl text-zinc-100 max-w-2xl leading-tight">
            Jméno, které nese <span className="gold-text">celé naše řemeslo</span>
          </h2>
        </Reveal>
        <div className="mt-14 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-px bg-gold/10 border border-gold/10">
          {ITEMS.map((item, i) => (
            <Reveal key={item.glyph} delay={i * 0.08} className="h-full">
              <div
                data-testid={`decoding-card-${i}`}
                className="group h-full bg-ink hover:bg-coal transition-colors duration-500 p-8 flex flex-col"
              >
                <span className="font-mono text-xs text-zinc-600">{item.num}</span>
                <span className="font-display text-6xl lg:text-7xl mt-6 text-zinc-200 group-hover:text-gold-light transition-colors duration-500">
                  {item.glyph}
                </span>
                <span className="mt-4 text-sm font-semibold tracking-[0.15em] uppercase text-gold/80">
                  {item.title}
                </span>
                <p className="mt-3 text-sm text-zinc-400 leading-relaxed">{item.text}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
